/* eslint-disable max-len */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useQuery } from 'react-query';
import styles from './transactions.module.scss';
import TitleComponent from '../title/title.component';
import CardComponent from '../card/card.component';
import BuyCreditComponent from '../buyCredits/buyCredits.component';
import { useCreditStore, useFacilitatorStore, useUserTransactions } from '../../store';
import {
  useGetCreditsByUserId,
  useGetAllFacilitator,
  useGetUserTransactions,
  useTransferCredits,
} from '../../services';
import ShowToast from '../ShowToast';
import Loader from '../Loader';

const TransactionsComponent = () => {
  const [showBuyCredit, setShowBuyCredit] = useState(false);
  const [selected, setSelected] = useState();
  const [numberOfCredits, setNumberOfCredits] = useState();
  const [selectedCredit, setSelectedCredit] = useState();
  const queryCredit = useGetCreditsByUserId();
  const queryTrans = useGetUserTransactions();
  const queryFacil = useGetAllFacilitator();

  const { refetch } = queryTrans;

  useEffect(() => {
    refetch();
  }, []);

  const halfCr = useCreditStore((s) => s.half_cr);
  const fullCr = useCreditStore((s) => s.full_cr);

  const [stateHalfCr, setStateHalfCr] = useState(halfCr);
  const [stateFullCr, setStateFullCr] = useState(fullCr);

  useEffect(() => {
    setStateHalfCr(halfCr);
    setStateFullCr(fullCr);
  }, [halfCr, fullCr]);

  const facilitators = useFacilitatorStore().facilitatorsList;
  const transactions = useUserTransactions().transactionList;

  const transfer = useTransferCredits();
  const newArray = [];

  const creditsOption = [
    {
      label: 'Half Credit',
      value: 'HALF',
    },
    {
      label: 'Full Credit',
      value: 'FULL',
    },
  ];

  facilitators.map((facil) =>
    facil.is_Certified ? newArray.push({ ...facil, label: facil.email, value: facil.id }) : null
  );

  const handleTransfer = async () => {
    if (!selected) {
      ShowToast('Please select Email to transfer Credit', 'error');
      return null;
    }
    if (!selectedCredit) {
      ShowToast('Please select credit type', 'error');
      return null;
    }
    if (!numberOfCredits) {
      ShowToast('Please select number of credits', 'error');
      return null;
    }

    if (selectedCredit.value === 'FULL' && numberOfCredits > fullCr) {
      ShowToast('Can not select more than availabel credits', 'error');
      return null;
    }

    if (selectedCredit.value === 'HALF' && numberOfCredits > halfCr) {
      ShowToast('Can not select more than availabel credits', 'error');
      return null;
    }

    if (numberOfCredits < 1) {
      ShowToast('Please select valid credits', 'error');
      return null;
    }

    var data = {
      email: selected.email,
      credit_type: selectedCredit.value,
      credit: parseInt(numberOfCredits),
    };

    setSelected(undefined);
    setNumberOfCredits(undefined);
    setSelectedCredit(undefined);

    await transfer.mutate(data);

    if (selectedCredit.value === 'FULL') {
      setStateFullCr(stateFullCr - numberOfCredits);
    }

    if (selectedCredit.value === 'HALF') {
      setStateHalfCr(stateHalfCr - numberOfCredits);
    }

    setSelected(null);
    setSelectedCredit(null);
    setNumberOfCredits(0);

    await refetch();
    await refetch();
    await refetch();
    await refetch();
    // await refetch();
  };

  return (
    <>
      {queryCredit.isLoading ? (
        <Loader />
      ) : queryTrans.isLoading ? (
        <Loader />
      ) : queryFacil.isLoading ? (
        <Loader />
      ) : queryTrans.isLoading ? (
        <Loader />
      ) : null}
      <div className={`w-75 pt-3 ${styles.title}`}>
        <TitleComponent title="Home/ Transactions" />
      </div>
      <div
        className={`container ${styles['box-shadow']}`}
        onClick={() => {
          if (showBuyCredit) setShowBuyCredit(false);
        }}>
        <CardComponent>
          <>
            <div className="container">
              <div className="row" style={{ paddingBottom: '8px' }}>
                <h6 className="col-8">
                  <strong>Transfer Credits</strong>
                </h6>
                <div className="col-4">
                  <div className="row">
                    <h6 className="col-12">
                      <strong>Half Day Credits: </strong>
                      {stateHalfCr}

                      <strong> Full Day Credits: </strong>
                      {stateFullCr}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Select
                    placeholder="Select Email Address"
                    options={newArray}
                    // isLoading={query.isLoading}
                    isClearable
                    isSearchable
                    // onInputChange={(v) => setSearch(v)}
                    onChange={(v) => setSelected(v)}
                    value={selected}
                  />
                  {/* <input
                    type="text"
                    className="form-control"
                    id="inputEmail"
                    placeholder="Email Address"
                  /> */}
                </div>
                <div className="col-3">
                  <Select
                    placeholder="Select Credit"
                    options={creditsOption}
                    // isLoading={query.isLoading}
                    isClearable
                    isSearchable
                    value={selectedCredit}
                    // onInputChange={(v) => setSearch(v)}
                    onChange={(v) => setSelectedCredit(v)}
                  />
                </div>
                <input
                  type="Number"
                  className="col-1"
                  value={numberOfCredits}
                  onChange={(e) => setNumberOfCredits(e.target.value)}
                />
                {/* <select>
                  <option defaultValue value="1">
                    1
                  </option>
                  <option value="2">2</option>

                  <option value="3">3</option>
                </select> */}
                <div className="col">
                  <button type="submit" className="btn btn-secondary" onClick={handleTransfer}>
                    Transfer
                  </button>
                </div>
                <div className="col">
                  <button
                    onClick={() => setShowBuyCredit(!showBuyCredit)}
                    type="button"
                    className="btn btn-secondary">
                    Buy Credits
                  </button>
                </div>
              </div>
              <div
                className={`${styles['navigation-bar-menu']}
                        ${showBuyCredit ? styles.active : ''}`}>
                {showBuyCredit && <BuyCreditComponent halfCr={halfCr} fullCr={fullCr} />}
              </div>
              <hr className="mt-3 mb-4" />
              <h6>
                <strong>Your Recent Transactions</strong>
              </h6>

              <div
                style={{
                  maxHeight: '300px',
                  overflow: 'auto',
                  background: 'white',
                  padding: '10px',
                }}>
                {transactions.map((trans) =>
                  trans.half_credits > 0 || trans.full_credits > 0 ? (
                    <p>
                      You {''}
                      {trans.trans_type === 'BUY'
                        ? 'bought'
                        : trans.trans_type === 'USE'
                        ? 'used'
                        : trans.trans_type === 'TRF_OUT'
                        ? 'transfered'
                        : trans.trans_type === 'TRF_IN'
                        ? 'received'
                        : null}{' '}
                      {trans.half_credits > 0 ? trans.half_credits : trans.full_credits}{' '}
                      {trans.half_credits > 0 ? 'Half-Day Credits' : 'Full-Day Credits'}{' '}
                      {trans.created_at}
                      {trans.creditSenderEmail
                        ? ` from ${trans.creditSenderEmail}`
                        : trans.creditReceiverEmail
                        ? ` to ${trans.creditReceiverEmail}`
                        : null}
                    </p>
                  ) : null
                )}
              </div>
            </div>
          </>
        </CardComponent>
      </div>
    </>
  );
};
export default TransactionsComponent;
